/**
 * Crystal (texture) source: http://spiralgraphics.biz/packs/crystal_rough/index.htm?5
 * @author Damian Browne
 */
import {
  Group,
  Vector3,
  Face3,
  MeshBasicMaterial,
  Mesh,
  Geometry,
  TextureLoader,
  Vector2,
  BackSide,
  MeshPhongMaterial,
  TorusGeometry
} from 'three'
import Crystal from '../textures/crystal.jpg'
import { setOpacity } from '../utilities/utilities'

class Pylon {
  constructor(radius, position, stop) {
    const loader = new TextureLoader()
    const texture = loader.load(Crystal)
    const geometry = new Geometry()
    geometry.vertices.push(
      new Vector3(-1, 0, 0), //0
      new Vector3(1, 0, 0), //1
      new Vector3(0, 0, -1), //2
      new Vector3(0, 0, 1), //3
      new Vector3(0, -1.75, 0), //4
      new Vector3(0, 1.75, 0) //5
    )
    geometry.faces.push(
      new Face3(2, 0, 4),
      new Face3(3, 4, 0),
      new Face3(0, 2, 5),
      new Face3(3, 0, 5),
      new Face3(1, 2, 4),
      new Face3(1, 4, 3),
      new Face3(1, 5, 2),
      new Face3(1, 3, 5)
    )
    for (let f = 0; f < geometry.faces.length; f++) {
      geometry.faceVertexUvs[geometry.faces[f].materialIndex].push([
        new Vector2(0, 0),
        new Vector2(0.5, 0),
        new Vector2(0.5, 0.5)
      ])
    }
    geometry.uvsNeedUpdate = true

    const material = new MeshBasicMaterial({
      map: texture,
      side: BackSide,
      transparent: true,
      opacity: 0.9,
      color: 0xccddff
    })
    const crystal = new Mesh(geometry, material)
    const ring = new Mesh(new TorusGeometry(1.2, 0.125, 10, 50), new MeshPhongMaterial({ color: 0xc9ad70 }))
    ring.rotation.x = Math.PI / 2
    this.group = new Group()
    this.group.add(crystal, ring)

    this.group.position.set(position.x, position.y, position.z)
    this.radius = radius
    this.group.scale.set(radius, radius, radius)
    this.velocity = { x: -0.3, y: 0 }
    this.maxVelocity = { y: 0.3 }
    this.stop = stop
    this.health = 80
    this.cooldown = { hit: 0 }
    this.type = 'pylon'
  }

  move(position) {
    this.group.position.x += -0.15
    this.group.rotation.y += 0.05
  }

  updateCooldowns() {
    if (this.cooldown.hit > 0) {
      this.cooldown.hit--
      if (this.cooldown.hit === 0) {
        setOpacity(this, 1)
      }
    }
  }
}

export default Pylon
